module.exports = __webpack_public_path__ + "img/marita_huurinainen.7702d742.jpg";